module.exports = __webpack_public_path__ + "static/media/plane.3118685c.svg";